import { useTracking } from '@/services/analytics/useTracking';
import {
    // eslint-disable-next-line @typescript-eslint/no-restricted-imports
    Button as ChakraButton,
    ButtonProps as ChakraButtonProps,
    // eslint-disable-next-line @typescript-eslint/no-restricted-imports
    IconButton as ChakraIconButton,
    IconButtonProps as ChakraIconButtonProps,
    // eslint-disable-next-line @typescript-eslint/no-restricted-imports
    MenuButton as ChakraMenuButton,
    MenuButtonProps as ChakraMenuButtonProps,
    forwardRef,
} from '@chakra-ui/react';
import { TrackingData, TrackingEventName } from '@common/react/tracking';
import { MouseEventHandler } from 'react';

export interface TrackClickEventProps {
    onClickEvent: TrackingEventName;
    onClickEventParams?: TrackingData;
}

export interface ButtonProps extends ChakraButtonProps, TrackClickEventProps {}

export const Button = forwardRef<ButtonProps, 'button'>(
    ({ onClickEvent, onClickEventParams, onClick, ...props }, ref) => {
        const { track } = useTracking();

        const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
            if (onClickEvent) {
                track(onClickEvent, onClickEventParams);
            }

            onClick?.(e);
        };

        return <ChakraButton ref={ref} onClick={handleClick} {...props} />;
    }
);

export interface IconButtonProps
    extends ChakraIconButtonProps,
        TrackClickEventProps {}

export const IconButton = forwardRef<IconButtonProps, 'button'>(
    ({ onClickEvent, onClickEventParams, onClick, ...props }, ref) => {
        const { track } = useTracking();

        const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
            if (onClickEvent) {
                track(onClickEvent, onClickEventParams);
            }

            onClick?.(e);
        };

        return <ChakraIconButton ref={ref} onClick={handleClick} {...props} />;
    }
);

export interface MenuButtonProps
    extends ChakraMenuButtonProps,
        TrackClickEventProps {}

export const MenuButton = forwardRef<MenuButtonProps, 'button'>(
    ({ onClickEvent, onClickEventParams, onClick, ...props }, ref) => {
        const { track } = useTracking();

        const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
            if (onClickEvent) {
                track(onClickEvent, onClickEventParams);
            }

            onClick?.(e);
        };

        return <ChakraMenuButton ref={ref} onClick={handleClick} {...props} />;
    }
);
